webpackJsonp([5],{

/***/ 158:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(158);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Team JS
 */

// CSS
(0, _jquery2.default)('.slideshow-team').slick({
  dots: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 768,
    settings: {
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});

// Vendors

/***/ })

},[186]);


// WEBPACK FOOTER //
// team.3211bb4d.js